import {Component, Input, OnInit, ViewChild} from "@angular/core";
import {OrderLineRevision, OrderLineRevisionSource} from "../../api";
import {ListViewComponent, ListViewSelectionMode} from "@tymes4-shared";
import {MatDialog} from "@angular/material/dialog";
import {OrderRevisionDetailsComponent} from "../../dialogs/order-revision-details/order-revision-details.component";

interface Mutation {
  Old: OrderLineRevision;
  New: OrderLineRevision;
}

@Component({
    selector: 't4-order-mutations',
    templateUrl: './order-mutations.component.html',
    styleUrls: ['./order-mutations.component.scss'],
    standalone: false
})
export class OrderMutationsComponent implements OnInit {
  @Input() revisions: OrderLineRevision[] = [];
  @ViewChild(ListViewComponent) listVw: ListViewComponent;

  public readonly OrderLineRevisionSource = OrderLineRevisionSource;

  public listOptions = {
    search: false,
    showBarcodeSearch: false,
    pageSize: 7,
    noItemsText: 'T4.ORDERMUTATIONS.MUTATIONLINES.NOLINES',
    selectionMode: ListViewSelectionMode.None,
    disableSort: true,
    renderInCard: false,
    noSpacing: true,
    headers: [
      {sortField: null, label: 'T4.ORDERMUTATIONS.HEADER.MUTATION-NUMBER', hideOn: null},
      {sortField: null, label: 'T4.ORDERMUTATIONS.HEADER.DATE', hideOn: null},
      {sortField: null, label: 'T4.ORDERMUTATIONS.HEADER.EDITED-BY', hideOn: null},
      {sortField: null, label: 'T4.ORDERMUTATIONS.HEADER.SOURCE', hideOn: null},
      {sortField: null, label: 'T4.ORDERMUTATIONS.HEADER.OLD-PRICE', hideOn: null},
      {sortField: null, label: 'T4.ORDERMUTATIONS.HEADER.NEW-PRICE', hideOn: null},
      {sortField: null, label: '', hideOn: null}
    ]
  };

  constructor(private dialog: MatDialog) {
  }

  ngOnInit(): void {
  }

  setListItems() {
    const revisionsByOrderLine = this.groupRevisionsByOrderLineId();
    const mutations = this.createMutationsFromGroupedRevisions(revisionsByOrderLine);

    this.listVw.Data = {
      TotalRecords: mutations.length,
      Records: mutations
    };
  }

  private groupRevisionsByOrderLineId(): Map<number, OrderLineRevision[]> {
    const grouped = new Map<number, OrderLineRevision[]>();
    for (const revision of this.revisions) {
      const orderLineId = revision.OrderLineId;
      if (!grouped.has(orderLineId)) {
        grouped.set(orderLineId, []);
      }
      grouped.get(orderLineId).push(revision);
    }

    return grouped;
  }

  private createMutationsFromGroupedRevisions(revisionsByOrderLine: Map<number, OrderLineRevision[]>): Mutation[] {
    const mutations: Mutation[] = [];
    for (const revisions of revisionsByOrderLine.values()) {
      for (let i = 1; i < revisions.length; i++) {
        mutations.push({
          Old: revisions[i],
          New: revisions[i - 1]
        });
      }
    }

    return mutations;
  }

  openRevisionDialog(revision: OrderLineRevision) {
    const orderLineRevisions = this.revisions.filter(x => x.OrderLineId === revision.OrderLineId);
    this.dialog.open(OrderRevisionDetailsComponent, {
      width: '95%',
      maxWidth: '100%',
      data: {revisions: orderLineRevisions, selected: revision.Id}
    });
  }
}
